/**
 * Copyright (c) 2018-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
export var editorProps = {
    apiKey: String,
    cloudChannel: {
        validator: function (val) {
            var validChannels = ['stable', 'testing', 'dev'];
            if (validChannels.indexOf(val.toLowerCase()) !== -1) {
                return true;
            }
            else {
                // tslint:disable-next-line:no-console
                console.error("VALIDATION ERROR! cloudChannel should be one of: " + validChannels.join(', '));
                return false;
            }
        }
    },
    id: String,
    init: Object,
    initialValue: String,
    inline: Boolean,
    modelEvents: [String, Array],
    plugins: [String, Array],
    tagName: String,
    toolbar: [String, Array],
    value: String
};



//////////////////
// WEBPACK FOOTER
// ./~/@tinymce/tinymce-vue/lib/es2015/components/EditorPropTypes.js
// module id = 381
// module chunks = 0